import FqApi from '@/services/fq-api'

export default {
  async getQuoteTemplateItems(templateId) {
    const url = `/quotetemplates/items/${templateId}`
    const result = await FqApi.get(url)
    return result.data
  }
}
